@if (demand) {
  <base-site-layout
    [heading]="heading | translate"
    headerIcon="fas fa-box"
    [loading]="!dataGroup && !priceGroup && !deliveryGroup"
    [errorCode]="error"
    [isDialog]="insideDialog"
    [message403]="'Der Bedarf kann leider nicht mehr bearbeitet werden' | translate"
    [message404]="'Der Bedarf existiert nicht' | translate"
    (dialogCloseClicked)="closeDialogUnlessSaving()"
    >
  @if (!insideDialog) {
    <button
      class="btn btn-secondary mb-2"
      [routerLink]="'/' + View.CLIENT + '/rfq/demand/' + demand.id"
      >
      <em class="px-1 fas fa-arrow-left"></em>
      {{ backBtnText | translate }}
    </button>
  }
  @if (dataGroup && priceGroup && deliveryGroup) {
    <div class="px-3 mt-3">
      <div class="row justify-content-center">
        <div class="col-xl-6 col-md-12 mb-2">
          <iim-card [header]="dataHeader">
            <ng-template #dataHeader>
              <div class="col">
                <div class="row">
                  <div class="col">
                    <h3>
                      <em class="fas fa-table pe-2"></em>
                      {{ 'Artikeldaten' | translate }}
                    </h3>
                  </div>
                </div>
              </div>
            </ng-template>
            <div class="col">
              <div class="row align-items-center">
                <div class="col">
                  <demand-product-data-input
                    [formGroup]="dataGroup"
                  ></demand-product-data-input>
                </div>
              </div>
            </div>
          </iim-card>
        </div>
        <div class="col-xl-6 col-md-12 mb-2 d-flex flex-column">
          <div class="row mb-2 flex-grow-1">
            <div class="col">
              <iim-card [header]="priceHeader">
                <ng-template #priceHeader>
                  <div class="col">
                    <h3>
                      <em class="fas fa-credit-card pe-2"></em>
                      {{ 'Preisinformationen' | translate }}
                    </h3>
                  </div>
                </ng-template>
                <div class="px-2 h-100">
                  <div class="row align-items-center h-100">
                    <div class="col h-100">
                      <div class="row align-items-center">
                        <div class="col">
                          @if (activeCurrencies) {
                            <demand-product-price-input
                              [formGroup]="priceGroup"
                              [activeCurrencies]="activeCurrencies"
                              [customerExcludedCurrencies]="customerExcludedCurrencies"
                              [supplierExcludedCurrencies]="supplierExcludedCurrencies"
                            ></demand-product-price-input>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </iim-card>
            </div>
          </div>
          <div class="row mb-2 flex-grow-1">
            <div class="col">
              <iim-card [header]="deliveryHeader">
                <ng-template #deliveryHeader>
                  <div class="col">
                    <h3>
                      <em class="fas fa-truck-fast pe-2"></em>
                      {{ 'Lieferinformationen' | translate }}
                    </h3>
                  </div>
                </ng-template>
                <div class="col h-100">
                  <div class="row align-items-center h-100">
                    <div class="col h-100">
                      <div class="row align-items-center">
                        <div class="col">
                          <demand-product-delivery-input
                            [formGroup]="deliveryGroup"
                          ></demand-product-delivery-input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </iim-card>
            </div>
          </div>
          <div class="row flex-grow-1">
            <div class="col">
              <iim-card [header]="fileHeader">
                <ng-template #fileHeader>
                  <div class="col">
                    <h3>
                      <em class="fas fa-file-arrow-up pe-2"></em>
                      {{ 'Datei' | translate }}
                    </h3>
                  </div>
                </ng-template>
                <div class="col h-100">
                  <div class="row h-100 justify-content-center align-items-center">
                    <div class="col-auto">
                      @if (!uploadData.length) {
                        <button
                          class="btn btn-outline-dark"
                          [disabled]="saving()"
                          (click)="upload()"
                          >
                          <em class="fas fa-plus pe-1"></em>
                          {{ 'Datei anhängen' | translate }}
                        </button>
                      } @else {
                        <div class="row mb-1 justify-content-center">
                          <mat-chip-listbox aria-orientation="vertical">
                            @for (fileEntry of uploadData; track fileEntry) {
                              <div class="col-auto">
                                <mat-chip
                                  class="alert-primary"
                                                            [ngClass]="
                                                                fileEntry.internal ? 'alert-info' : 'alert-primary'
                                                            "
                                  >
                                  @if (fileEntry.internal) {
                                    <em
                                      class="fas fa-eye-slash pe-1"
                                    ></em>
                                  }
                                  <span class="small">
                                    {{ fileEntry.fileName }}
                                    @if (fileEntry.internal) {
                                      <span
                                        class="text-description"
                                        >
                                        ({{ 'intern' | translate }})
                                      </span>
                                    }
                                  </span>
                                  <em
                                    class="fas fa-download cursor-pointer margin-horizontal-10"
                                    (click)="download(fileEntry)"
                                  ></em>
                                  <em
                                    class="fas fa-times cursor-pointer text-danger margin-horizontal-10"
                                    (click)="removeFile(fileEntry)"
                                  ></em>
                                </mat-chip>
                              </div>
                            }
                            <div class="col-auto">
                              <button class="btn btn-sm btn-outline-dark" [disabled]="saving()" (click)="upload()">
                                <em class="fas fa-plus fa-1_5x"></em>
                              </button>
                            </div>
                          </mat-chip-listbox>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </iim-card>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col">
          <iim-card [header]="commentsHeader">
            <ng-template #commentsHeader>
              <div class="col">
                <div class="row">
                  <div class="col">
                    <h3>
                      <em class="fas fa-note-sticky pe-2"></em>
                      {{ 'Kommentar' | translate }}
                    </h3>
                  </div>
                </div>
              </div>
            </ng-template>
            <div class="col">
              <div class="row mb-2">
                <div class="col-auto">
                  <strong>
                    {{ 'Kommentar zum Artikel' | translate }} -
                    <span class="text-description">{{ 'optional' | translate }}</span>
                  </strong>
                </div>
                <div class="col-12">
                  <textarea class="form-control" rows="5" [formControl]="commentCtrl"></textarea>
                </div>
              </div>
            </div>
          </iim-card>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col">
          <iim-card [header]="internalCommentsHeader">
            <ng-template #internalCommentsHeader>
              <div class="col">
                <div class="row">
                  <div class="col">
                    <h3>
                      <em class="fas fa-note-sticky pe-2"></em>
                      {{ 'Interner Kommentar' | translate }}
                    </h3>
                  </div>
                </div>
              </div>
            </ng-template>
            <div class="col">
              <div class="row mb-2">
                <div class="col-auto">
                  <strong>
                    {{ 'Interner Kommentar zum Artikel' | translate }} -
                    <span class="text-description">{{ 'optional' | translate }}</span>
                  </strong>
                </div>
                <div class="col-12">
                  <textarea
                    class="form-control"
                    rows="5"
                    maxlength="250"
                    [formControl]="internalCommentCtrl"
                  ></textarea>
                  <div class="text-end text-muted mt-1">
                    <small>
                      {{ internalCommentCtrl.value?.length || 0 }}/250 {{ 'Zeichen' | translate }}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </iim-card>
        </div>
      </div>
      <div class="row justify-content-end mb-3">
        <div class="col-md-auto col-12">
          <button
            class="btn btn-primary d-flex align-items-center w-100 justify-content-center"
            data-cy="ADD_ARTICLE_BTN"
            [disabled]="saving() || dataGroup.invalid || priceGroup.invalid || deliveryGroup.invalid"
            (click)="createAndSaveNewPosition()"
            >
            @if (saving()) {
              <em class="fas fa-spinner fa-spin px-1"></em>
            } @else {
              <em class="fas fa-plus px-1"></em>
            }
            {{ 'Weitere Position hinzufügen' | translate }}
          </button>
        </div>
        <div class="col-md-auto col-12">
          <button
            class="btn btn-success d-flex align-items-center w-100 mt-2 mt-md-0 justify-content-center"
            data-cy="SAVE_ARTICLE_BTN"
            [disabled]="saving() || dataGroup.invalid || priceGroup.invalid || deliveryGroup.invalid"
            (click)="saveNewPosition()"
            >
            @if (saving()) {
              <em class="fas fa-spinner fa-spin px-1"></em>
            } @else {
              <em class="fas fa-floppy-disk px-1"></em>
            }
            {{ 'Speichern' | translate }}
          </button>
        </div>
      </div>
    </div>
  }
</base-site-layout>
}
